export const BASE_URL = 'https://dsdspl.com/mp_funds/public/api/';

// Helper function to get headers with auth token
function getHeaders() {
  const auth = storage.getAuth();
  const headers = {};
  
  if (auth?.access_token) {
    headers['Authorization'] = `Bearer ${auth.access_token}`;
  }
  
  return headers;
}

export async function postForm(path, formData) {
  const response = await fetch(new URL(path, BASE_URL).toString(), {
    method: 'POST',
    headers: getHeaders(),
    body: formData
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Request failed');
  }
  return await response.json();
}

export async function get(path) {
  const url = new URL(path, BASE_URL).toString();
  const response = await fetch(url, { 
    headers: getHeaders()
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Request failed');
  }
  return await response.json();
}

export async function put(path, data) {
  const url = new URL(path, BASE_URL).toString();
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...getHeaders()
    },
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Request failed');
  }
  return await response.json();
}

export async function del(path) {
  const url = new URL(path, BASE_URL).toString();
  const response = await fetch(url, {
    method: 'DELETE',
    headers: getHeaders()
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Request failed');
  }
  return await response.json();
}

export const storage = {
  saveAuth(payload) {
    try {
      window.localStorage.setItem('mp_auth', JSON.stringify(payload));
    } catch {}
  },
  getAuth() {
    try {
      const v = window.localStorage.getItem('mp_auth');
      return v ? JSON.parse(v) : null;
    } catch {
      return null;
    }
  },
  clearAuth() {
    try {
      window.localStorage.removeItem('mp_auth');
    } catch {}
  }
};